import { render, staticRenderFns } from "./reportePoker.vue?vue&type=template&id=f42be30c&"
import script from "./reportePoker.vue?vue&type=script&lang=js&"
export * from "./reportePoker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports